<div class="vtr-modal-reboot-machine"
	id="modal-reboot-machine"
	role="dialog"
	aria-modal="true">
	<div class="modal-header">
		<h4 id="ds-reboot-popup"
			ngbAutofocus>
			{{'device.deviceSettings.inputAccessories.inputAccessory.topRowFunctions.popup.title' | translate}}
		</h4>
		<button type="button"
				id="btnClose"
				class="close-button"
				#btnClose
				role="button"
				aria-label="reboot popup close"
				tabindex="0"
				(click)="closeModal()"
				(keydown.esc)="closeModal()"
				(keydown.enter)="closeModal()">
				<fa-icon [icon]="['fal', 'times']"></fa-icon>
		</button>
	</div>

	<div class="modal-body">
		<p id="ds-rebootpopup-description2">{{description | translate}}</p>
		
		<hr aria-hidden="true">

		<div class="row mt-3">
			<vtr-ui-button [isFullWidth]="true"
				(click)="proceedToReboot()"
				role="button"
				[alreadyJoinGroup]="'groupNone'"
				[linkId]="'reboot-popup-enable'"
				[label]="'device.deviceSettings.inputAccessories.inputAccessory.topRowFunctions.popup.reboot' | translate"
				aria-label="reboot popup enable">
			</vtr-ui-button>
			<a id="reboot-popup-cancel"
				role="link"
				tabindex="0"
				aria-label="reboot popup cancel"
				(click)="closeModal()"
				(keydown.enter)="closeModal()"
				class="hyperlink-button align-self-center cancel-link">
				{{'device.deviceSettings.inputAccessories.inputAccessory.topRowFunctions.popup.cancel' | translate}}
			</a>
		</div>
	</div>
</div>